/**
 * greetingCards — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const greetingCardsPack: ToilePack = {
    slug: 'greeting-cards',
    category: 'greeting',
    name: 'Greeting cards',
    tagline: tagline('cards', 'occasions', 'styles'),
    chips: chips('occasions', 'styles'),
    ratio: A4,
    readings: [
        {key: 'birthday', label: 'Happy birthday', subject: 'a layered cake with lit candles, confetti and streamers'},
        {key: 'thanks', label: 'Thank you', subject: 'a small posy of garden flowers tied with string'},
        {key: 'congrats', label: 'Congratulations', subject: 'bursting party poppers, laurel leaves and rising sparks'},
    ],
    styles: [
        {key: 'lettered', label: 'Hand-lettered', style: 'brush calligraphy wreathed in watercolor blooms', palette: 'soft ink-on-paper edges', framing: 'card front, flat and straight on'},
        {key: 'midcentury', label: 'Mid-century', style: 'flat 1950s shapes, chunky retro lettering', palette: 'mustard, teal and coral, printed grain', framing: 'card front, flat and straight on'},
        {key: 'gold', label: 'Gold minimal', style: 'one small motif, thin gold foil lettering', palette: 'metallic gold on ivory, mostly empty', framing: 'card front, flat and straight on'},
    ],
    directions: ['a get-well card instead', 'in soft pastels', 'quieter, less on the page'],
}
